<template>
  <v-container fluid="fluid" grid-list-md="grid-list-md">
    <Create
      :createDialog="createDialog"
      @close="createDialog = !createDialog"
      @submit="getList"
    ></Create>
    <Edit
      :editDialog="editDialog"
      @close="editDialog = !editDialog"
      @submit="getList"
      :editProduct="selectedProduct"
    ></Edit>
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t("pageHeader.product") }}</h1>
        </v-toolbar-title>
        <v-btn
          color="teal"
          dark="dark"
          small="small"
          absolute="absolute"
          bottom="bottom"
          right="right"
          fab="fab"
          @click="add"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12="xs12" sm4="sm4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line="single-line"
            hide-details="hide-details"
            clearable="clearable"
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="products"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr class="pointer">
            <td class="text-xs-left">{{ props.item.productDetail }}</td>
            <td class="text-xs-left">{{ props.item.productType }}</td>
            <td class="text-xs-center">{{ props.item.stock }}</td>
            <td class="text-xs-right">{{ props.item.amount | currency }}</td>
            <td class="justify-end layout px-0">
              <v-menu bottom="bottom" left="left" offset-y="offset-y">
                <v-btn slot="activator" icon="icon"><v-icon>more_vert</v-icon></v-btn>
                <v-list class="menu-button">
                  <v-list-tile @click="editProduct(props.item)">
                    <v-list-tile-title>{{ $t("buttons.edit") }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import productService from "../service";

const Create = () => import("./Create");
const Edit = () => import("./Edit");

export default {
  name: "product-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedProduct: null,
      headers: [
        {
          text: this.$t("labels.name"),
          align: "left",
          value: "productDetail",
          sortable: true
        },
        {
          text: "Product Type",
          align: "left",
          value: "productType",
          sortable: true
        },
        {
          text: this.$t("labels.stock"),
          value: "stock",
          sortable: true
        },
        {
          text: this.$t("labels.amount"),
          value: "amount",
          sortable: true
        },
        {
          text: "",
          value: "action",
          sortable: false
        }
      ],
      products: [],
      search: null,
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "createdAt",
        descending: false
      }
    };
  },
  created() {
    this.getList();
    console.log('router', this.$route.query)
    if (this.$route.query && this.$route.query.search) {
      this.search = this.$route.query.search
    }
  },
  components: {
    Create,
    Edit
  },
  methods: {
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      (this.editDialog = false), (this.createDialog = false);
      return productService.getAll().then(response => {
        console.log("dfdfdfd", response);
        this.loading = false;
        this.products = response.data;
        return response;
      });
    },
    editProduct(product) {
      this.selectedProduct = product;
      this.editDialog = !this.editDialog;
    },
    deleteProduct(product) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          productService.delete(product.id).then(response => {
            if (response.data) {
              this.$swal("Deleted!", "Product has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    }
  }
};
</script>
